import { useTranslation } from 'react-i18next'

const SalesPersonEnd = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="sales-person-end-title"
      {...props}
    >
      <title id="sales-person-adult-end-title">{t('antagonists:salesPerson:components:end')}</title>
      <path
        d="M1422.46 541.81s.25 43.81-4.2 54.15c-4.45 10.34-16.34 30.29-17.39 36.01-.54 2.96 3.12 26.41 3.99 27.64 1.6 2.23 18.34 9.24 18.34 9.24s2.19-2.83 1.01-5.44c-2.07-4.61-5.73-9.34-6.37-10.93s-1.13-6.68-.39-10.44c.74-3.77 2.46-9.97 4.69-9.02s-1.77 9.64-2.42 12.77c-.65 3.13-.48 8.1-.48 8.1s3.87 2.65 4.58 1.84c1.44-1.62 3.71-3.94 5.35-9.52 1.64-5.57 2.49-7.81 4.82-12.21 2.33-4.4 5.61-31.53 4.76-37.86-.73-5.5 10.91-49.55 10.91-49.55l-27.21-4.77Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1430.77 478.85c.2-7.67 2.96-49.33 3.89-81.22 1.02-34.88 4.46-51.77 24.64-54.56l18.26 40.43s-10.12 85.97-12.14 107.95c-.68 7.43-17.7 71.63-17.7 71.63l-29.41-3.01s12.41-79.35 12.45-81.22Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1580.35 1006.51c10.64-.28 16.54-6.62 18.02-9.19 1.47-2.57.31-24.33-.73-34.57-.95-9.4.26-25.57-9.22-29.56-4.52-1.9-23.93-1.96-24.3 8.34-.37 10.29-.62 37.09-.98 44.08-.37 6.99-.38 13.13 3.61 15.76 3.65 2.4 10.12 5.24 13.6 5.15ZM1510.9 1007.87c5.39.37 14.71-2.57 17.65-5.15 2.94-2.57 5.19-9.61 3.31-18.38-2.3-10.75-2.53-33.44-2.21-39.84.23-4.77-2.93-19.35-13.96-17.51-11.03 1.84-21.04 4.21-20.51 21.67.25 8.38 1.02 28.33-.08 36.79s-1.4 16.11 2.69 18.32c4.12 2.22 8.83 3.82 13.12 4.11Z"
        style={{
          fill: '#bd2e86',
        }}
      />
      <path
        d="M1479.55 626.84s.26 100.12 2.48 113.45c2.22 13.33-6.66 60.72-4.44 82.93 2.22 22.21 17.03 82.93 18.51 90.33 1.48 7.4-1.75 15.28.82 20.43s1.1 16.91 1.47 23.53c.37 6.62-2.09 28.81 3.79 29.54 5.88.74 23.78.6 25.25-3.07 1.47-3.68-1.84-16.54-.74-24.63s-.74-10.66-1.47-16.91-2.57-12.87-3.68-19.49c-1.1-6.62-5.15-18.02-3.31-28.68 1.84-10.66 8.82-52.21 7.72-73.9-1.1-21.69-4.78-34.56-2.94-43.75 1.84-9.19 7.35-19.12 6.62-36.4-.74-17.28 23.49-114.59 23.49-114.59l-73.59 1.21Z"
        style={{
          fill: '#f2bfba',
        }}
      />
      <path
        d="M1517.84 634.44s12.13 118.75 18.38 136.03c6.25 17.28 9.19 28.68 10.29 39.71 1.1 11.03 3.31 30.15 9.56 50.74 6.25 20.59 12.5 33.82 12.13 43.75-.37 9.93-1.84 17.34-2.67 22.47-.88 5.49.46 19.44.46 29.37s-1.84 19.85 1.1 22.06c2.94 2.21 21.78 2.47 24.72 1.74 2.94-.74 3.32-14.96 2.95-25.25-.37-10.29-4.51-13.99-4.14-19.5.37-5.51.37-11.03.37-23.53s7.39-76.93 5.15-101.11c-2.36-25.5-18.19-54.26-18.56-65.29-.37-11.03-3.27-105.52-3.27-105.52l-56.48-5.67Z"
        style={{
          fill: '#f2bfba',
        }}
      />
      <path
        d="M1629.88 539.88s-.25 43.81 4.2 54.15c4.45 10.34 16.34 30.29 17.39 36.01.54 2.96-3.12 26.41-3.99 27.64-1.6 2.23-18.34 9.24-18.34 9.24s-2.19-2.83-1.01-5.44c2.07-4.61 5.73-9.34 6.37-10.93.64-1.59 1.13-6.68.39-10.44-.74-3.77-2.46-9.97-4.69-9.02s1.77 9.64 2.42 12.77c.65 3.13.48 8.1.48 8.1s-3.87 2.65-4.58 1.84c-1.44-1.62-3.71-3.94-5.35-9.52-1.64-5.57-2.49-7.81-4.82-12.21-2.33-4.4-5.61-31.53-4.76-37.86.73-5.5-10.91-49.56-10.91-49.56l27.21-4.77Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1528.1 206.89c-4-.07-11.94-4.69-23.62 4.12-21.37 16.12-22.26 67.19-24.12 89.02-2.03 23.94-4.24 122.98-4.24 122.98l93.91 1.38s13.68-99.66 9.54-129.09c-3.02-21.44-6.04-39.82-10.24-53.93-4.39-14.75-9.58-25.34-20.55-32.21-7.61-4.76-15.23-2.18-20.69-2.27Z"
        style={{
          fill: '#c1a172',
        }}
      />
      <path
        d="M1508.73 277.4s5.42 23.03 5.33 28.34c-.09 5.31.91 18.4-7.59 21.49-13.76 5-30.36 9.36-30.36 9.36l-19.42 7.86 4 41.72s132.74 12.54 131.99 12.73-12.49-59.23-12.49-59.23-16.16-5.6-23.77-9.65c-6.94-3.7-2.76-14.54-2.08-24.07.88-12.27 3.51-19.37 3.51-19.37l-49.14-9.17Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1533.2 227.91c-6.92.58-9.77 11.02-15.9 19.08-7.55 9.94-9.58 9.54-13.26 15.46-7.05 11.34-.67 24.95-.67 24.95s13.31 24.5 26.57 25.79c13.27 1.29 16.47-1.42 23.06-7.82s9.77-14.07 11.33-19.54c1.34-4.68-6.15-28.86-10.41-35.09-5.68-8.3-16.21-23.22-20.72-22.84Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1567.6 281.42c-.78 1.94-4.04-.03-4.04-.03s-4.84-17.85-5.26-18.38c0 0 5.53-5.46 7.9-4.1 3.72 2.14 1 5.35 1.19 10.73 0 .2 1.61 8.29.21 11.77ZM1498.75 285.92c1.66 1.27 6.12-2.35 6.12-2.35s-1.01-18.49-.69-19.09c0 0-5.59-3.35-7.95-1.99s-1.99 4.22-1.19 9.54 2.05 12.61 3.71 13.88Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1527.63 289.25c.32 1.51 5.38 6.94 9.91 6.9 4.53-.05 8.95-3.46 9.19-5.51.23-2.05-.78-6.59-3.45-6.33-2.67.26-3.58.55-4.51.44-.93-.11-1.83-.98-4.56-.16-2.73.82-7.18 1.76-6.57 4.66Z"
        style={{
          fill: '#e95b27',
        }}
      />
      <path
        d="m1525.76 250.23-1.19 4.48s-9.37-1.55-12.39-1.16c-3.02.4-7.84 2.57-7.84 2.57l-.79-2.49s4.76-4.43 10.37-4.12a1333 1333 0 0 1 11.85.72ZM1540.96 249.3s10.58-3.3 13.75-2.21c2.92 1.01 5.32 3.66 5.32 3.66l-.89 1.61s-2.99-2.33-6.23-1.86-11.22 2.44-11.22 2.44l-.73-3.65Z"
        style={{
          fill: '#c1a172',
        }}
      />
      <path
        d="m1510.81 261.49 12.42.17s-.68-7.42-8.05-5.98c-4.66.91-4.37 5.81-4.37 5.81ZM1556.95 257.57l-11.84 2.63s-.63-6.91 6.42-7.3c4.49-.25 5.42 4.67 5.42 4.67Z"
        style={{
          fill: '#0095d8',
        }}
      />
      <path
        d="m1518.23 264.24-2.72 2.26-1.44-1.73 3.6-2.92s.69 2.27.57 2.4Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1518.36 263.06-6.5-.27v-1.88l5.91.04.59 2.11z"
      />
      <path
        d="M1516.64 261.21c-.56 1.94.36 3.69 2.28 4.16 1.92.47 3.34-.43 3.95-2.14.72-2.02-.26-3.48-2.19-4.17-1.36-.49-3.46.15-4.04 2.15ZM1550.45 261.59l3.17 1.99 1.04-1.54-4.01-2.91s-.33 2.34-.2 2.46Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1550.52 260.41 6.15-1.21-.61-2.32-5.29 1.43-.25 2.1z"
      />
      <path
        d="M1551.16 258.93c.85 1.83.21 3.7-1.62 4.46-1.83.76-3.48.18-4.34-1.41-1.02-1.88-.16-3.58 1.64-4.56 1.27-.69 3.45-.38 4.32 1.51ZM1621.57 476.91c-.2-7.67-3.36-41.24-4.29-73.12-1.02-34.88-1.98-59-22.17-61.8l-20.34 39.57s10.12 85.97 12.14 107.95c.68 7.43 17.7 71.63 17.7 71.63l27.35-1.58s-10.35-80.78-10.39-82.65Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1579.85 482.05c-.65-15.81 20.67-52.9 22.38-73.35 1.7-20.45 5.34-63.44-4.46-66-9.8-2.56-29.67-8.37-29.67-8.37s-8.46 2.94-36.54 1.65c-19.33-.89-35.46-6.82-35.46-6.82s-29.36 9.16-43.85 16.4c-14.49 7.24-4.98 27.48-1.14 45.38 3.84 17.9 22.75 73.24 22 87.81-2.01 39.06-21.78 44.6-24.42 100.89-2.27 48.51 3.02 92.36 12.19 169.61 0 0 35.26 4.53 70.86 3.25 35.46-1.28 69.15-11.17 69.15-11.17s4-119.48.98-160.35c-2.84-38.5-20.85-70.51-22.02-98.93Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1482.63 280.98s-8.57 57.63-12.74 88c-4.3 31.25-2.59 58.18-2.59 58.18s31.78 3.57 44.78-15.95 3.26-57.16.76-74.64 0-29.44 0-29.44l-30.21-26.14Z"
        style={{
          fill: '#c1a172',
        }}
      />
    </svg>
  )
}

export default SalesPersonEnd